/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs/Observable';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { CCDAIP, LabOrders } from '../model/models';
import { environment } from '../../environments/environment';

@Injectable()
export class ClinicalSummaryService {

    protected basePath = environment.appSetting.apiUrl + 'patientemr';
    protected basePathPT = environment.appSetting.apiUrl + 'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetPatientPortalMedicationList
     * This API get PatientPortalMedicationList
     */
    public ClinicalSummary(searchJson: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public ClinicalSummary(searchJson: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public ClinicalSummary(searchJson: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public ClinicalSummary(searchJson: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (searchJson !== undefined && searchJson !== null) {
            queryParameters = queryParameters.set('Search', <any>searchJson);
        }
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetEMRClinicalSummary`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public GenerateCCDAV2(ccdaData: CCDAIP, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];


        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        formParams = formParams.append('patientId', <any>ccdaData.patientId) || formParams;

        formParams = formParams.append('startDate', <any>ccdaData.startDate) || formParams;

        formParams = formParams.append('endDate', <any>ccdaData.endDate) || formParams;

        formParams = formParams.append('userId', <any>ccdaData.userId) || formParams;

        formParams = formParams.append('DocumentType', <any>ccdaData.DocumentType) || formParams;

        formParams = formParams.append('practiceID', <any>ccdaData.practiceID) || formParams;

        formParams = formParams.append('practiceHeader', <any>ccdaData.practiceHeader) || formParams;

        formParams = formParams.append('patientPicturesFolderPath', <any>ccdaData.patientPicturesFolderPath) || formParams;

        formParams = formParams.append('requestType', <any>ccdaData.requestType) || formParams;
        formParams = formParams.append('sender', <any>ccdaData.sender) || formParams;
        formParams = formParams.append('subject', <any>ccdaData.subject) || formParams;
        formParams = formParams.append('message', <any>ccdaData.message) || formParams;

        return this.httpClient.post<any>(`${this.basePathPT}/GenerateCCDAV2`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                // params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
